import type React from 'react';
import Head from 'next/head';
import { formatTitle } from '@itandi/tools/vanilla';

type Props = {
  title: string;
};

export const NskHead: React.FC<Props> = ({ title }: Props) => (
  <Head>
    <title>{formatTitle(title, 'nsk')}</title>
  </Head>
);
